import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/companies-verification-listings';

export const FETCH_COMPANIES_VERIFICATION_DETAILS = defineApiActionTypes(
  `${prefix}/FETCH_COMPANIES_VERIFICATION_DETAILS`
);



// WEBPACK FOOTER //
// ./src/store/features/companies-verification-listings/action-types.js